import type { RuntimeArray } from './runtime-array.js';

/**
 * Τιμές κατά την εκτέλεση. Δεν γίνεται διάκριση ΑΚΕΡΑΙΕΣ/ΠΡΑΓΜΑΤΙΚΕΣ στο
 * runtime (και οι δύο JS number) — ο σημασιολογικός έλεγχος τύπων είναι
 * ξεχωριστή, μελλοντική φάση.
 */
export type RuntimeValue = ScalarRuntimeValue | RuntimeArray;

/** Οι «απλές» τιμές — ό,τι μπορεί να τυπωθεί/συγκριθεί απευθείας (όχι ολόκληρος πίνακας). */
export type ScalarRuntimeValue = number | string | boolean;

export function formatRuntimeValue(value: ScalarRuntimeValue): string {
  if (typeof value === 'boolean') return value ? 'ΑΛΗΘΗΣ' : 'ΨΕΥΔΗΣ';
  return String(value);
}

export function describeRuntimeValue(value: RuntimeValue): string {
  if (typeof value === 'boolean') return value ? 'ΑΛΗΘΗΣ' : 'ΨΕΥΔΗΣ';
  if (typeof value === 'number' || typeof value === 'string') return JSON.stringify(value);
  return 'πίνακας';
}
